import './Branch.css'

// import { Grid, TableBody, TableCell, TableRow } from '@material-ui/core'
import { clearBranch, deleteBranchAction, getBranchAction } from 'actions/branchActions'
// import { IMAGES } from 'assets'
import {
  dataSearchResult,
  formatDateWithPadding,
  getSessionInfo,
  getTitleModalConfirm,
  getUserKbAdmin,
} from 'commons/utilities'
import {
  // Image,
  MessageErrorDialog,
  ModalConfirm as DeleteResult,
  ModalConfirm,
  ProgressDialog,
  // SearchCalendar,
  // SearchFormInput,
  // SelectInput,
} from 'components/commons'
import TableCommon from 'components/commons/Table/TableCommon'
import ToolBar from 'components/commons/ToolBar/ToolBar'
import {
  DELETE_BRANCH_FAILED,
  DELETE_BRANCH_REQUEST,
  DELETE_BRANCH_SUCCESS,
  GET_BRANCH_LIST_FAILED,
  GET_BRANCH_LIST_REQUEST,
  GET_BRANCH_LIST_SUCCESS,
} from 'constants/actionTypes/branchActionTypes'
import {
  ACTION_FORM,
  DATE_TYPE,
  FILTER_ITEMS,
  FLAG_BOOLEAN,
  MESSAGE_TYPE,
  SCREEN_NAME,
  SPECIAL_CELL_TYPE,
  TOOLBAR_TYPE,
} from 'constants/constant'
import React, { useEffect, useRef, useState } from 'react'
// import { CSVLink } from 'react-csv'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'

// import styles from './BranchStyles'
function Branch() {
  const sysInfo = useSelector((state) => {
    if (state.systemInfo && state.systemInfo.system) return state.systemInfo.system
    return {}
  })
  const userInfo = useSelector((state) => {
    if (state.userInfo && state.userInfo.userInfo && state.userInfo.userInfo.data) return state.userInfo.userInfo.data
    return null
  })
  const DT_TODAY = sysInfo?.DT_TODAY
    ? formatDateWithPadding(sysInfo?.DT_TODAY, 'yyyy-MM-dd')
    : formatDateWithPadding(new Date(), 'yyyy-MM-dd')
  const { t } = useTranslation()
  // const classes = styles()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [listData, setListData] = useState([])
  const [searchInput, setSearchInput] = useState('')
  const [dateFilter, setDateFilter] = useState(DT_TODAY)
  const [filterDateParams, setFilterDateParams] = useState({
    dateType: '',
    date: DT_TODAY,
  })
  // const [searchData, setSearchData] = useState([])
  const [filterItem, setFilterItem] = useState(FILTER_ITEMS[1])
  const [filterData, setFilterData] = useState([])
  const [loading, setLoading] = useState(false)
  const [messageError, setMessageError] = useState()
  const [recordDelete, setRecordDelete] = useState()
  const [isValidDate, setIsValidDate] = useState(true)
  const [isInDateRange, setIsInDateRange] = useState(true)

  const listBranchReducer = useSelector((state) => state.listBranch || {})
  const branchDeleteReducer = useSelector((state) => state.deleteBranch || {})
  const filteredFields = ['CD_BRANCH', 'NM_BRANCH', 'AN_BRANCH']

  const [deletePermissionMessageError, setDeletePermissionMessageError] = useState('')

  const [showModalConfirmDelete, setShowModalConfirmDelete] = useState(false)
  const [deletePopUp, setDeletePopUp] = useState(false)
  const [deleteMessageType, setDeleteMessageType] = useState('')

  const firstRender = useRef(true)

  const handleSearchInput = (event) => {
    event.preventDefault()
    setFilterData(dataSearchResult(listData, filteredFields, searchInput))
  }

  const handleFilterDate = React.useCallback(
    (date) => {
      if (isValidDate && isInDateRange) {
        let params = {
          dateType: filterItem === FILTER_ITEMS[0] ? DATE_TYPE.START : DATE_TYPE.END,
          date: date,
        }
        setFilterDateParams(params)
        dispatch(getBranchAction(params))
      }
    },
    [dispatch, filterItem]
  )

  const handleDeleteOnClick = async (data) => {
    const kbAdmin = await getUserKbAdmin(userInfo)
    if (String(kbAdmin) === FLAG_BOOLEAN.FALSE) {
      setShowModalConfirmDelete(false)
      setDeletePermissionMessageError(t('commonComponent.noDeletePermission'))
    } else {
      setShowModalConfirmDelete(true)
      setRecordDelete(data)
    }
  }

  const deleteBranch = () => {
    setShowModalConfirmDelete(false)
    if (filterDateParams && filterDateParams.dateType && filterDateParams.date) {
      filterDateParams.dateType === DATE_TYPE.START ? setFilterItem(FILTER_ITEMS[0]) : setFilterItem(FILTER_ITEMS[1])
      dispatch(deleteBranchAction(recordDelete, filterDateParams))
    } else {
      dispatch(deleteBranchAction(recordDelete))
    }
  }

  // handle edit portal
  const navigateToFormBranch = (id, data, type = ACTION_FORM.CREATE) => {
    history.push({
      pathname: '/admin/branch-form',
      search: `?${id ? `id=${id}&` : ''}type=${type}`,
      state: {
        type: type,
        data: data,
        date: filterDateParams,
        searchInput: searchInput,
        screen: SCREEN_NAME.BRANCH,
      },
    })
  }

  useEffect(() => {
    const { date, searchInput, screen } = location?.state || {}
    if (searchInput && screen === SCREEN_NAME.BRANCH) {
      setSearchInput(searchInput)
    }
    if (date && date.dateType && date.date && screen === SCREEN_NAME.BRANCH) {
      date.dateType === DATE_TYPE.START ? setFilterItem(FILTER_ITEMS[0]) : setFilterItem(FILTER_ITEMS[1])
      setDateFilter(date.date)
      setFilterDateParams(date)
      dispatch(getBranchAction(date))
    } else {
      dispatch(getBranchAction({}))
    }
    window.history.replaceState({}, document.title)
  }, [dispatch, location])

  useEffect(() => {
    let dateParams = {
      dateType: filterItem === FILTER_ITEMS[0] ? DATE_TYPE.START : DATE_TYPE.END,
      date: dateFilter,
    }

    if (!firstRender.current) {
      // dateParams.dateType = DATE_TYPE.END
      setFilterDateParams(dateParams)
      dispatch(getBranchAction(dateParams))
    }

    if (firstRender.current) {
      firstRender.current = false
    }
  }, [filterItem])

  useEffect(() => {
    if (listData.length >= 0 && searchInput === '') {
      setFilterData(listData)
    }
  }, [listData, searchInput])

  useEffect(() => {
    setDeletePopUp(false)
    if (listBranchReducer.listBranch.length >= 0) {
      let dataResponse = [...listBranchReducer.listBranch]
      setListData(dataResponse)
      if (searchInput !== '') {
        setFilterData(dataSearchResult(dataResponse, filteredFields, searchInput))
      }
    }

    setLoading(listBranchReducer.loading)
    switch (listBranchReducer.type) {
      case GET_BRANCH_LIST_REQUEST:
        break
      case GET_BRANCH_LIST_FAILED:
        if (!getSessionInfo()) {
          listBranchReducer.message && setMessageError(listBranchReducer.message)
        }

        break
      case GET_BRANCH_LIST_SUCCESS:
        break
      default:
        return
    }

    switch (branchDeleteReducer.type) {
      case DELETE_BRANCH_REQUEST:
      case DELETE_BRANCH_SUCCESS:
        // setRecordDelete(null)
        break
      case DELETE_BRANCH_FAILED:
        if (!getSessionInfo()) {
          setMessageError(branchDeleteReducer.message)
        }
        break
      default:
        return
    }
  }, [listBranchReducer])

  useEffect(() => {
    setLoading(listBranchReducer.loading || branchDeleteReducer.loading)
    switch (branchDeleteReducer.type) {
      case DELETE_BRANCH_REQUEST:
        break
      case DELETE_BRANCH_SUCCESS:
        // setRecordDelete(null)
        setDeleteMessageType(MESSAGE_TYPE.SUCCESS)
        setDeletePopUp(true)
        break
      case DELETE_BRANCH_FAILED:
        if (!getSessionInfo()) {
          setDeletePopUp(true)
          setDeleteMessageType(MESSAGE_TYPE.ERROR)
          setMessageError(branchDeleteReducer.message)
        }
        break
      default:
        return
    }
  }, [branchDeleteReducer])
  const headersCsv = [
    { label: t('branch.lblBranchCode'), key: 'CD_BRANCH' },
    { label: t('branch.lblNmBranch'), key: 'NM_BRANCH' },
    { label: t('branch.lblAnBranch'), key: 'AN_BRANCH' },
    { label: t('branch.lblDtStart'), key: 'DT_START' },
    { label: t('branch.lblDtEnd'), key: 'DT_END' },
  ]
  const headerCsvLabel = headersCsv.map((data) => data.label)
  const headerCsvKey = headersCsv.map((data) => data.key)

  const listColumnWidth = ['62px', '12%', '45%', '15%', '10%', '']

  const listCellHeader = [
    { columnName: '', commonStyle: 'titleHead', cellStyle: '' },
    { columnName: 'branch.lblCdBranch', commonStyle: 'titleHead', cellStyle: 'titleSpacing' },
    { columnName: 'branch.lblNmBranch', commonStyle: 'titleHead', cellStyle: 'titleSpacing' },
    { columnName: 'branch.lblAnBranch', commonStyle: 'titleHead', cellStyle: 'personTitle' },
    { columnName: 'branch.lblDtStart', commonStyle: 'titleHead', cellStyle: 'dateTitle' },
    { columnName: 'branch.lblDtEnd', commonStyle: 'titleHead', cellStyle: 'dateTitle' },
  ]

  const listCellBody = [
    { keyValue: 'CD_BRANCH', cellStyle: 'data', gridStyle: 'centerAlignHq' },
    { keyValue: 'NM_BRANCH', cellStyle: 'data', gridStyle: 'centerAlignHq' },
    { keyValue: 'AN_BRANCH', cellStyle: 'dataRight', gridStyle: 'centerAlignHq' },
    { specialType: SPECIAL_CELL_TYPE.DATE_START },
    { specialType: SPECIAL_CELL_TYPE.DATE_END },
  ]

  const listToolBarComponent = [
    { type: TOOLBAR_TYPE.ADD, commonStyle: 'createContainer', componentStyle: '' },
    { type: TOOLBAR_TYPE.FILTER_LOGO, commonStyle: 'filterIconContainer', componentStyle: '' },
    { type: TOOLBAR_TYPE.SEARCH, commonStyle: 'searchContainer', componentStyle: 'search-item' },
    { type: TOOLBAR_TYPE.FILTER_DATE, commonStyle: 'select-item', componentStyle: '' },
    { type: TOOLBAR_TYPE.CALENDAR, commonStyle: 'filterContainer', componentStyle: 'calendar-item' },
    { type: TOOLBAR_TYPE.CSV, commonStyle: '', componentStyle: '' },
  ]
  let setDownloadParams = {
    screenName: 'branch',
    searchText: searchInput,
    date: dateFilter,
    dateType: filterItem === FILTER_ITEMS[0] ? DATE_TYPE.START : DATE_TYPE.END,
  }

  const toolbar = (
    <ToolBar
      listToolBarComponent={listToolBarComponent}
      handleCreateOnclick={navigateToFormBranch}
      setSearchInput={setSearchInput}
      searchInput={searchInput}
      handleSubmit={handleSearchInput}
      handleFilterDate={handleFilterDate}
      setSelectedDate={setDateFilter}
      selectedDate={dateFilter}
      headerCsvLabel={headerCsvLabel}
      headerCsvKey={headerCsvKey}
      fileCsvName={t('branch.fileNameDownload')}
      listData={listData}
      customClassTitleFitlerIcon={'toolbarTitleNotTextWrap'}
      setFilterItem={setFilterItem}
      filterItem={filterItem}
      csvButtonStyle={true}
      toolbarWidth={'SMALL'}
      downloadParams={setDownloadParams}
      setIsValidDate={setIsValidDate}
      setIsInDateRange={setIsInDateRange}
    />
  )

  const msgDeleteConfirm = recordDelete
    ? getTitleModalConfirm(
        t('branch.msgDeleteConfirm.line1', { cdBranchValue: recordDelete.CD_BRANCH }),
        t('branch.msgDeleteConfirm.line2')
      )
    : ''

  const handleConfirmDeleteResult = () => {
    setRecordDelete(null)
    setDeletePopUp(false)
    dispatch(getBranchAction())
    dispatch(clearBranch())
  }

  return (
    <div className="branch__wrapper branch__maintain-wrapper">
      {messageError && <MessageErrorDialog message={messageError} showMessageErrorDialog={setMessageError} />}
      {loading && <ProgressDialog label={recordDelete ? t('branch.msgDeleteData') : t('branch.loading')} />}
      {deletePermissionMessageError && (
        <MessageErrorDialog
          message={deletePermissionMessageError}
          showMessageErrorDialog={setDeletePermissionMessageError}
        />
      )}

      <DeleteResult
        title={deleteMessageType === MESSAGE_TYPE.SUCCESS ? t('branch.deleteDataSuccess') : t('branch.deleteDataError')}
        showModal={deletePopUp}
        handleFunction={handleConfirmDeleteResult}
        screen={'branch'}
      />

      <ModalConfirm
        title={msgDeleteConfirm}
        showModal={showModalConfirmDelete}
        setShowModal={setShowModalConfirmDelete}
        handleFunction={deleteBranch}
      />
      {loading ? (
        <ProgressDialog label={recordDelete ? t('branch.msgDeleteData') : t('branch.loading')} />
      ) : (
        <div className="branch__container maintain-container">
          {/* Table */}
          <TableCommon
            tableWidth={'SMALL'}
            listColumnWidth={listColumnWidth}
            listCellHeader={listCellHeader}
            listCellBody={listCellBody}
            listDataRender={filterData}
            handleUpdate={navigateToFormBranch}
            idProperty={'CD_BRANCH'}
            handleDelete={handleDeleteOnClick}
            toolbar={toolbar}
          />
        </div>
      )}
    </div>
  )
}

export default Branch
